import CategoryList from "./category_list";

function ProductCategories() {
  return <CategoryList />;
}

export default ProductCategories;
